import React, { useState } from 'react';
import { Box, TextField, IconButton, Typography } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { useChat } from '../../../contexts/ChatContext';

interface ChatInputAreaProps {
    onSendMessage: (text: string) => void;
}

export const ChatInputArea: React.FC<ChatInputAreaProps> = ({ onSendMessage }) => {
    const { activeChoices, isServiceUnavailable } = useChat(); // <--- Estratto isServiceUnavailable
    const [inputValue, setInputValue] = useState('');

    const handleSend = () => {
        if (!inputValue.trim() || isServiceUnavailable) return; // Blocco preventivo sull'invio
        onSendMessage(inputValue);
        setInputValue('');
    };

    // Helper per determinare dinamicamente il testo del placeholder
    const getPlaceholderText = () => {
        if (isServiceUnavailable) return "Chat disabled - Service unavailable";
        if (activeChoices) return "Make a Choice...";
        return "Type a message...";
    };

    return (
        <Box
            data-tour={"ask_ai_chat_input"}
            sx={{
            p: 2,
            backgroundColor: 'background.paper',
            borderTop: '1px solid',
            borderColor: 'divider',
            display: 'flex',
            flexDirection: 'column',
            gap: 0.5,
            width: '100%',
            boxSizing: 'border-box'
        }}>

            <Typography
                variant="caption"
                sx={{
                    color: 'text.disabled',
                    fontSize: '10px',
                    fontWeight: 500,
                    letterSpacing: '0.3px',
                    userSelect: 'none'
                }}
            >
                Powered by Nemantix<sup>®</sup>
            </Typography>

            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', width: '100%' }}>
                <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    placeholder={getPlaceholderText()} // <--- Placeholder dinamico
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    multiline
                    maxRows={3}
                    disabled={!!activeChoices || isServiceUnavailable} // <--- Disabilitato se 503
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                            e.preventDefault();
                            handleSend();
                        }
                    }}
                    sx={{ minWidth: 0 }}
                />
                <IconButton
                    color="primary"
                    onClick={handleSend}
                    disabled={!!activeChoices || !inputValue.trim() || isServiceUnavailable} // <--- Disabilitato se 503
                    sx={{ p: '8px', flexShrink: 0 }}
                >
                    <SendIcon />
                </IconButton>
            </Box>
        </Box>
    );
};